export const CURRENCIES = {
    USD: 'usd',
}
